module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2OC41IDY4LjUiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojMWNiYmI0O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQ2FwYV8yIiBkYXRhLW5hbWU9IkNhcGEgMiI+PGcgaWQ9IkNhcGFfMS0yIiBkYXRhLW5hbWU9IkNhcGEgMSI+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIzNC4yNSIgY3k9IjM0LjI1IiByPSIzNC4yNSIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTM0LjI1LDQuMzZBMjkuODksMjkuODksMCwxLDAsNjQuMTQsMzQuMjVoMEEyOS44OCwyOS44OCwwLDAsMCwzNC4yNiw0LjM2WiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/station_marker.svg
// module id = 1p4A
// module chunks = 1